/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const SignupTypeEnum = {
  ENROLLED: "E",
  UNENROLLED: "U",
  WAITLISTED: "W",
  PURCHASE_HOLD: "P",
  AUTO_CANCELLED: "A",
} as const;

export type SignupTypeEnum =
  (typeof SignupTypeEnum)[keyof typeof SignupTypeEnum];

export type SignupTypeEnumEnumType = typeof SignupTypeEnum;
export type SignupTypeEnumOptional = SignupTypeEnum;
export type SignupTypeEnumTrackedI = SignupTypeEnum;
export type SignupTypeEnumTracked = SignupTypeEnum;
export type SignupTypeEnumMetaI = EnumMetaType<
  SignupTypeEnumEnumType,
  SignupTypeEnum
>;
export const SignupTypeEnumMeta = typeMetaEnum<
  SignupTypeEnumEnumType,
  SignupTypeEnum
>("SignupTypeEnum", SignupTypeEnum);
export function transformDatesSignupTypeEnum(model: SignupTypeEnum) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
